import * as React from "react";

export function StreakIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 28 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.838 21.326c0 .562.439.988 1.043.988h7.96l-4.186 11.24c-.563 1.495.988 2.291 1.976 1.084l12.818-15.865c.247-.316.37-.604.37-.92 0-.576-.438-.988-1.042-.988h-7.96l4.186-11.254c.562-1.496-.988-2.292-1.977-1.07L4.222 20.406c-.247.302-.384.59-.384.92z"
        fill="currentColor"
      />
    </svg>
  );
}
